__turbopack_context__.v({
  "className": "source_serif_4_8b635ba9-module__Z-Gbqq__className",
  "variable": "source_serif_4_8b635ba9-module__Z-Gbqq__variable",
});
